import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '../views/MainLayout.vue'
import authStore from '../store/authStore'
import { getRouteRedirect } from '../utils/permissions.mjs'

Vue.use(VueRouter)

const routes = [
  {
    path: '/screen',
    name: 'StationScreen',
    component: () => import(/* webpackChunkName: "StationScreen" */ '../views/StationScreen.vue')
  },
  {
    path: '/actual-power',
    name: 'ActualPower',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "ActualPower" */ '../views/ActualPower.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
  },
  {
    path: '/admin',
    component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/AdminLayout.vue'),
    redirect: '/admin/overview',
    meta: { requiresAuth: true, permission: 'manage' },
    children: [
      {
        path: 'stations',
        name: 'StationManage',
        redirect: '/admin/overview'
      },
      {
        path: 'data',
        name: 'DataManage',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/DataManage.vue')
      },
      {
        path: 'overview',
        name: 'DataOverview',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/DataOverview.vue')
      },
      {
        path: 'users',
        name: 'UserManage',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/UserManage.vue')
      },
      {
        path: 'turbines',
        name: 'WindTurbineManage',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/WindTurbineManage.vue')
      },
      {
        path: 'solar-panels',
        name: 'SolarPanelManage',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/admin/SolarPanelManage.vue')
      }
    ]
  },
  {
    path: '/',
    component: MainLayout,
    // 根路径按权限 viewType 跳转默认大屏
    redirect: () => authStore.homePath,
    children: [
      {
        path: 'wind',
        name: 'WindHome',
        component: () => import(/* webpackChunkName: "WindHome" */ '../views/WindHome.vue'),
        meta: { requiresAuth: true, permission: 'wind' }
      },
      {
        path: 'solar',
        name: 'SolarHome',
        component: () => import(/* webpackChunkName: "SolarHome" */ '../views/SolarHome.vue'),
        meta: { requiresAuth: true, permission: 'solar' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 登录验证
router.beforeEach((to, from, next) => {
  const redirect = getRouteRedirect(to, authStore.state)
  if (redirect) next(redirect)
  else next()
})

export default router
